import React from 'react';

export interface OverlayProps {
  children?: React.ReactNode;
  onClick?: () => void;
  showSpinner?: boolean;
}

const Overlay: React.FC<OverlayProps> = ({ onClick, showSpinner = true }) => {
  //eslint-disable-next-line tailwindcss/no-custom-classname
  return (
    <div
      className="fixed left-0 top-0 z-[100] size-full bg-gray-400/40"
      onClick={onClick}
      data-testid="atom-overlay"
      role="presentation"
    >
      <div className="flex h-screen items-center justify-center">
        {showSpinner && (
          <svg className="z-[300] size-60 animate-spin" viewBox="0 0 100 100" aria-hidden="true" data-testid="atom-overlay-spinner">
            <circle fill="none" strokeWidth="10" className="stroke-current opacity-40" cx="50" cy="50" r="40" />
            <circle
              fill="none"
              strokeWidth="10"
              className="stroke-current"
              strokeDasharray="250"
              strokeDashoffset="210"
              cx="50"
              cy="50"
              r="40"
            />
          </svg>
        )}
      </div>
    </div>
  );
};

export default Overlay;
